import { ArrowUpRight } from "lucide-react";
import { useFlowReveal } from "@/hooks/useFlowReveal";

// Names and one-line descriptions come from each organisation's own site. Logos
// sit on a white tile so they read the same in light and dark themes. Names
// only: no claims about the work done.
const clients = [
  {
    name: "Plutus Advisors",
    what: "SEBI-registered research analyst",
    href: "https://www.plutusadvisors.com",
    logo: "/clients/plutus-advisors.webp",
    w: 640,
    h: 456,
  },
  {
    name: "NV Capital",
    what: "Category II alternative investment fund",
    href: "https://nvcap.in/",
    logo: "/clients/nv-capital.png",
    w: 315,
    h: 60,
  },
  {
    name: "AutomateDocs",
    what: "AI document automation platform",
    href: "https://automatedocs.ai/",
    logo: "/clients/automatedocs.webp",
    w: 720,
    h: 135,
  },
];

const ClientsSection = () => {
  const flowRef = useFlowReveal<HTMLUListElement>();

  return (
  <section className="px-6 py-12 md:px-8 lg:px-16" aria-labelledby="clients-heading">
    <div className="max-w-7xl mx-auto">
      <h2 id="clients-heading" className="eyebrow mb-6">
        Our clients
      </h2>
      <ul ref={flowRef} className="grid list-none gap-6 sm:grid-cols-3">
        {clients.map((c, i) => (
          <li key={c.name} className="flow-step" style={{ "--i": Math.min(i, 5) } as React.CSSProperties}>
            <a
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group block rounded-lg focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-focus-ring"
            >
              {/* The logo is decorative: the organisation's name is the link text. */}
              <span className="logo-tile flex h-28 items-center justify-center rounded-lg border border-border bg-white p-3 transition-colors group-hover:border-primary/50">
                <img
                  src={c.logo}
                  alt=""
                  width={c.w}
                  height={c.h}
                  loading="lazy"
                  decoding="async"
                  className="max-h-full w-auto max-w-full object-contain"
                />
              </span>
              <span className="mt-4 flex items-center gap-1.5 font-display text-xl font-bold text-foreground group-hover:text-primary">
                {c.name}
                <ArrowUpRight size={16} className="text-muted-foreground group-hover:text-primary" aria-hidden="true" />
                <span className="sr-only">(opens in a new tab)</span>
              </span>
              <span className="mt-1 block text-base text-muted-foreground">{c.what}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  </section>
  );
};

export default ClientsSection;
